// extracted by css-extract-rspack-plugin
export default {"sortingMenuButton":"sorting-dropdown-module__sortingMenuButton__a7SNEj2"};